import { Pipe, PipeTransform } from "@angular/core";
import { IObservationDefinition, IObservationDefinitionComponent, IObservationsLoincsInfo } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "getShortname",
})
export class GetShortnamePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  /**
   * Get shortname of the observationDefinitionComponent if available. If not, returns the name of the component. If still not available, return the loinc
   */
  transform(element: IObservationDefinitionComponent | IObservationDefinition | IObservationsLoincsInfo): string {
    if (!element) return "...";
    if (element.shortnameTranslation && element.shortnameTranslation[this.translateService.currentLang]) {
      return element.shortnameTranslation[this.translateService.currentLang];
    } else if (element.nameTranslation && element.nameTranslation[this.translateService.currentLang]) {
      return element.nameTranslation[this.translateService.currentLang];
    } else {
      return element.loinc;
    }
  }
}
